import {Component, Input, OnInit, ViewChild} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';
import {SubReportComponent, SubReportElementComponent, SubReportFilter} from '../fields-interventions-general-ii-report.component';
import {DxDataGridComponent} from 'devextreme-angular';
import {Workbook, Worksheet} from 'exceljs';
import {Tractor, Trailer, durationToStr} from 'shared';
import {exportDataGrid} from 'devextreme/excel_exporter';
import moment from 'moment';
import {sortBy, groupBy, map, sumBy, flatten, filter as f} from 'lodash';
import {TractorService} from '../../../../../stores/tractor.service';
import {TrailerService} from '../../../../../stores/trailer.service';
import {UserDomainService} from '../../../../../user-domains/user-domain.service';

@Component({
  selector: 'app-material-usage',
  templateUrl: './material-usage.component.html',
  styleUrls: ['./material-usage.component.scss'],
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportComponent.outputs,
})
export class MaterialUsageComponent extends SubReportComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor(
    private tractorService: TractorService,
    private trailerService: TrailerService,
    private userDomainsService: UserDomainService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.title = `${this.romainIndex}. L'UTILISATION DU MATERIEL`;

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: workBook => this.export(workBook),
      loader: (isReload, filter, data) => this.load(isReload, filter, data)
    });
  }

  async load(isReload: boolean, filter: SubReportFilter, data): Promise<any> {
    const ids = filter.domainIds();
    const options = {
      paginate: false,
      filter: ['domain_id', '=', ids],
    };

    const d = await Promise.all([
      this.userDomainsService.userDomainsWithAreas().toPromise(),
      this.tractorService.newDataSource(options).load(),
      this.trailerService.newDataSource(options).load(),
    ]);

    return super.load(isReload, filter, d);
  }

  getWorkSheetName(): string {
    return this.title;
  }
}

/* -----------------------------------------
-- Table 1
-------------------------------------------- */
@Component({
  selector: 'app-material-usage-table-1',
  template: `
    <dx-data-grid
      class="p-4"
      [columnAutoWidth]="true"
      width="90%"
      [showBorders]="true">
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-export [enabled]="true"></dxo-export>
    </dx-data-grid>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialUsageTable1Component extends SubReportElementComponent implements OnInit {

  @ViewChild(DxDataGridComponent)
  grid: DxDataGridComponent;

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });
  }

  load(isReload: boolean, filter: SubReportFilter, [domains, tractors, trailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const interventions = f(this.store.createQuery().toArray(), i => ids.indexOf(i.field.domain_id) !== -1);
    this.ds = flatten(map(groupBy(interventions, 'domain_name'), (pg, domainName) => {
      return map(groupBy(pg, (t) => {
        return moment(t.start_time).format('MMMM').toUpperCase();
      }), (g, month) => {
        return {
          Domaine: domainName,
          Mois: month,
          'Duree travaux brut': durationToStr(g.reduce((sum, ii) => {
            return sum + ii.total_duration;
          }, 0)),
          'Duree travaux arrets': durationToStr(g.reduce((sum, ii) => {
            return sum + ii.total_road_duration;
          }, 0)),
          'Duree trajet': durationToStr(g.reduce((sum, ii) => {
            return sum + ii.total_working_duration;
          }, 0)),
          'Duree travaux effectif': durationToStr(g.reduce((sum, ii) => {
            return sum + ii.drive_working_duration;
          }, 0)),
        };
      });
    }));


    this.grid.instance.on('contentReady', () => {
      this.grid.instance.columnOption(0,
        hasMultipleDomains ? {groupIndex: 0, visible: true} : {groupIndex: null, visible: false});

      this.grid.instance.off('contentReady');
    });
    this.grid.instance.option('dataSource', this.ds);

    return Promise.resolve(undefined);
  }
}


/* -----------------------------------------
-- Chart 1
-------------------------------------------- */
@Component({
  selector: 'app-material-usage-chart-1',
  template: `
    <dx-accordion
      class="p-4"
      width="90%"
      [dataSource]="ds"
      [collapsible]="false"
      [multiple]="false"
      [animationDuration]="300">
      <div *dxTemplate="let d of 'title'">
        <h4 class="group-title">{{d.title}}</h4>
      </div>
      <div *dxTemplate="let d of 'item'">
        <dx-pie-chart
          class="p-2 m-auto w-1/2"
          palette="bright"
          [size]="{width: 520,  height: 500}"
          [dataSource]="d.data">
          <dxo-legend
            orientation="horizontal"
            itemTextPosition="right"
            horizontalAlignment="center"
            verticalAlignment="bottom"
            [columnCount]="4"></dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-title [text]="d.title">
            <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
          </dxo-title>
          <dxi-value-axis [visible]="false"></dxi-value-axis>
          <dxi-series
            argumentField="name"
            valueField="duration">
            <dxo-label
              [visible]="true"
              position="columns"
              [customizeText]="customizeLabel">
              <dxo-font [size]="12"></dxo-font>
              <dxo-connector
                [visible]="true"
                [width]="0.5"></dxo-connector>
            </dxo-label>
          </dxi-series>
        </dx-pie-chart>
      </div>
    </dx-accordion>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialUsageChart1Component extends SubReportElementComponent implements OnInit {

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    /*workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });*/

    return Promise.resolve(undefined);
  }

  load(isReload: boolean, filter, [domains, tractors, oTrailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const interventions = f(this.store.createQuery().toArray(), i => ids.indexOf(i.field.domain_id) !== -1);
    this.ds = map(groupBy(interventions, 'domain_name'), (g, domainName) => {
      return {
        domain: domainName,
        title: domainName + ': Durée Travaux (%)',
        data: [
          {
            name: 'Duree travaux effectif', duration: (g.reduce((sum, ii) => {
              return sum + ii.drive_working_duration;
            }, 0))
          },
          {
            name: 'Duree trajet', duration: (g.reduce((sum, ii) => {
              return sum + ii.total_road_duration;
            }, 0))
          },
          {
            name: 'Duree travaux arrets', duration: (g.reduce((sum, ii) => {
              return sum + ii.stop_working_duration;
            }, 0))
          }]
      };
    });

    if (hasMultipleDomains) {
      this.ds.unshift({
        domain: 'Total',
        title: 'Total: Durée Travaux (%)',
        data: [{
          name: 'Duree travaux effectif', duration: (interventions.reduce((sum, ii) => {
            return sum + ii.drive_working_duration;
          }, 0))
        },
          {
            name: 'Duree trajet', duration: (interventions.reduce((sum, ii) => {
              return sum + ii.total_road_duration;
            }, 0))
          },
          {
            name: 'Duree travaux arrets', duration: (interventions.reduce((sum, ii) => {
              return sum + ii.stop_working_duration;
            }, 0))
          }]
      });
    }

    return Promise.resolve(undefined);
  }

  customizeLabel(arg) {
    return durationToStr(arg.value) + ' (' + arg.percentText + ')';
  }
}


/* -----------------------------------------
-- Chart 2
-------------------------------------------- */
@Component({
  selector: 'app-material-usage-chart-2',
  template: `
    <dx-accordion
      class="p-4"
      width="90%"
      [dataSource]="ds"
      [collapsible]="false"
      [multiple]="false"
      [animationDuration]="300">
      <div *dxTemplate="let d of 'title'">
        <h4 class="group-title">{{d.title}}</h4>
      </div>
      <div *dxTemplate="let d of 'item'">
        <dx-pie-chart
          class="p-2 m-auto w-1/2"
          palette="bright"
          [size]="{width: 520,  height: 500}"
          [dataSource]="d.data">
          <dxo-legend
            orientation="horizontal"
            itemTextPosition="right"
            horizontalAlignment="center"
            verticalAlignment="bottom"
            [columnCount]="4"></dxo-legend>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-title [text]="d.title">
            <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
          </dxo-title>
          <dxi-value-axis [visible]="false"></dxi-value-axis>
          <dxi-series
            argumentField="Puissance"
            valueField="Duration">
            <dxo-label
              [visible]="true"
              position="columns"
              [customizeText]="customizeLabel">
              <dxo-font [size]="12"></dxo-font>
              <dxo-connector
                [visible]="true"
                [width]="0.5"></dxo-connector>
            </dxo-label>
          </dxi-series>
        </dx-pie-chart>
      </div>
    </dx-accordion>
  `,
  // tslint:disable-next-line:no-inputs-metadata-property
  inputs: SubReportElementComponent.inputs,
  // tslint:disable-next-line:no-outputs-metadata-property
  outputs: SubReportElementComponent.outputs,
})
export class MaterialUsageChart2Component extends SubReportElementComponent implements OnInit {

  ds = [];

  constructor() {
    super();
  }

  ngOnInit(): void {

    // Raise the loaded event
    this.initialized.emit({
      index: this.index,
      export: (workBook, workSheet, topLeftCell) => this.export(workBook, workSheet, topLeftCell),
      loader: (isReload, filter, data) => this.load(isReload, filter, data),
    });
  }

  export(workBook: Workbook, workSheet: Worksheet, topLeftCell): Promise<any> {
    /*workSheet.mergeCells(workSheet.rowCount, 1, workSheet.rowCount, 10);
    return exportDataGrid({
      component: this.grid.instance,
      worksheet: workSheet,
      customizeCell: ({excelCell, gridCell}) => {

      },
      topLeftCell
    });*/

    return Promise.resolve(undefined);
  }

  load(isReload: boolean, filter, [domains, all, oTrailers]) {
    const hasMultipleDomains = filter.domains.length > 1;
    const ids = filter.domainIds();
    const interventions = f(this.store.createQuery().toArray(), i => ids.indexOf(i.field.domain_id) !== -1);
    this.ds = map(groupBy(interventions, 'domain_name'), (g, domainName) => {
      return {
        domain: domainName,
        title: domainName + ': Nbre d\'heures des tracteurs',
        data: map(groupBy(g, 'engine_power_category'), (gg, ep) => {
          return {
            Puissance: ep,
            Duration: gg.reduce((sum, ii) => {
              return sum + ii.total_duration;
            }, 0),
          };
        })
      };
    });

    if (hasMultipleDomains) {
      this.ds.unshift({
        domain: 'Total',
        title: 'Total: Nbre d\'heures des tracteurs',
        data: map(groupBy(interventions, 'engine_power_category'), (gg, ep) => {
          return {
            Puissance: ep,
            Duration: gg.reduce((sum, ii) => {
              return sum + ii.total_duration;
            }, 0),
          };
        })
      });
    }

    return Promise.resolve(undefined);
  }

  customizeLabel(arg) {
    return durationToStr(arg.value) + ' (' + arg.percentText + ')';
  }
}
